import { inject } from "vue";
export default {
  components: {},
  props: {
    items: Array,
    check: Boolean
  },
  setup() {
    const {
      countFavorite
    } = inject("items");
    return {
      countFavorite
    };
  }
};